import Debug from 'debug';
const debug = Debug('gh:lobuilder:pushnotify');

const getFirebaseMessagingObject = () => {
    const config = {
        apiKey: "AIzaSyDPPvsDeVGDd0wusuN8VtDXy83IqQWXIT4",
        authDomain: "glasshouse-48765.firebaseapp.com",
        databaseURL: "https://glasshouse-48765.firebaseio.com",
        projectId: "glasshouse-48765",
        storageBucket: "glasshouse-48765.appspot.com",
        messagingSenderId: "89999032466"
    };

    firebase.initializeApp(config);

    return firebase.messaging();
};

const register = (messaging) => {
    if (!navigator.serviceWorker || !messaging) {
        return;
    }

    navigator.serviceWorker.register('./firebase-messaging-sw.js').then(() => {
        debug(navigator.serviceWorker.ready);
        return navigator.serviceWorker.ready;
    }).catch((error) => {
        debug(error);
    }).then((registration) => {
        messaging.useServiceWorker(registration);

        messaging.requestPermission().then(() => {
            debug('Notification permission granted.');

            messaging.getToken().then((token) => {
                debug(token);

                const options = {
                    method  : 'PUT',
                    headers : new Headers({ 'Content-Type' : 'application/json', 'Authorization': `Bearer ${Cookies.get('apiToken')}`}),
                    body    : JSON.stringify({ 'FirebaseToken': token })
                };

                fetch(`/api/member/${window.memberID}`, options).then((res) => {
                    debug(res);
                    window.sessionStorage.setItem('pushnotify:registered', true);
                }).catch((error) => {
                    console.error(error);
                });
            }).catch((error) => {
                console.error(error);
            });

        }).catch((error) => {
            debug('Unable to get permission to notify.', error);
        });
    });
};

if((!window.sessionStorage.getItem('pushnotify:registered') || window.sessionStorage.getItem('pushnotify:registered') === null) && window.WebNotificationEnabled){
    register(getFirebaseMessagingObject());
}



// WEBPACK FOOTER //
// Glasshouse/Core/js/pushnotify/push.js